<div class="clientes tab-pane fade show active">
  <form>
    <div class="cabeceraTabla row">
      <div class="col-12 col-md-3 col-sm-5">
        <label translate>cli.receiverList.dire</label>
        <input type="text" name="buscadorDIRe" placeholder="{{'cli.receiverList.placeholderDire' | translate}}" class="col-12" [(ngModel)]="filter.direName" (keyup)="onKeyUp()">
      </div>
      <div class="col-12 col-md-3 col-sm-5">
        <label translate>cli.receiverList.platform</label>
        <input type="text" name="buscadorPlatform" placeholder="{{'cli.receiverList.placeholderPlatform' | translate}}" class="col-12" [(ngModel)]="filter.platformName" (keyup)="onKeyUp()">
      </div>
      <div class="col btActivaDesactiva align-bottom" *ngIf="isDataSelected()">
      <div class="pull-right">
          <button class=" btn btn-primary " translate type="button" (click)="onActivateReceiversClicked()"><i class="fa fa fa-lightbulb-o"></i>cli.receiverList.active</button>
          <button class=" btn btn-primary" translate type="button" (click)="onDesactivateReceiversClicked()"><i class="fa fa fa-ban"></i>cli.receiverList.desactive</button>
      </div>
    </div>
    </div>
  </form>
  <table class="table table-hover table-striped">
    <thead>
    <tr>
      <th class="ocultatabletlVertical">
        <label class="form-check-label pseudocheck">
            <input type="checkbox" class="form-check-input" (click)="onSelectAllClicked()" [(ngModel)]="swSelectAll">

        </label>
      </th>
      <th scope="col">
        <span class="d-none d-md-block" translate>cli.receiverList.headerDireFull
        </span>
        <span class="d-block d-md-none" translate>cli.receiverList.headerDire</span>
      </th>
      <th scope="col">
        <span class="d-none d-md-block" translate>cli.receiverList.headerPlatformFull</span>
        <span class="d-block d-md-none" translate>cli.receiverList.headerPlatform</span>
      </th>
      <th scope="col" class="text-center d-none d-sm-table-cell">
        <span translate>cli.receiverList.headerStatus</span>
      </th>
      <th scope="col" class="text-center d-none d-md-table-cell">
        <span translate>cli.receiverList.headerAction</span>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngIf="receiverList.items.length === 0" class="noResultFound">
        <td colspan="5"><span translate>cli.receiverList.noResultFound</span></td>
      </tr>
    <tr *ngFor="let receiver of receiverList.items | paginate: { itemsPerPage: itemsPerPage, currentPage: p }; let i=index">
      <td class="ocultatabletlVertical">
        <label class="form-check-label pseudocheck">
            <input type="checkbox" class="form-check-input" [(ngModel)]="receiver.selected" *ngIf="receiver.status != 'CI'">
            <span></span>
        </label>
      </td>
      <td>
        <span class="d-none d-sm-block">{{ receiver.dire.code }}</span><span class="truncateTD">{{ receiver.dire.name }}</span></td>
      <td><span class="truncateTD">{{ receiver.platform.name }}</span></td>
      <td class="text-center d-none d-sm-table-cell">
        <span *ngIf="receiver.status === 'CI'" translate>cli.receiverList.statusCI</span>
        <span *ngIf="receiver.status === 'CC'" translate>cli.receiverList.statusCC</span>
        <span *ngIf="receiver.status === 'A'" translate>cli.receiverList.statusA</span>
      </td>
      <td class="text-center d-none d-md-table-cell">
        <button [title]="getStatusTitle(receiver)" [disabled]="receiver.status === 'CI'" (click)="onUpdateReceiverStatusClicked(receiver)"><i [class]=" receiver.status === 'A' ? 'fa fa-ban' : 'fa fa-lightbulb-o'"> <span class="d-none d-md-inline-block" translate>{{getStatusTitle(receiver)}}</span></i></button>
      </td>
    </tr>
    </tbody>
  </table>

  <div *ngIf="receiverList.items.length > 0" class="paginador">
    <pagination-controls (pageChange)="p = $event" autoHide="true"
                         previousLabel="{{'inv.list.previous' | translate}}"
                         nextLabel="{{'inv.list.next' | translate}}" class="pull-right">
    </pagination-controls>

    <div class="controlPaginador pull-left">
      <label class="d-none d-sm-inline-block" translate>cli.list.receiversPage</label>
      <select [(ngModel)]="itemsPerPage" class="custom-select">
        <option value="5" selected>5</option>
        <option value="10">10</option>
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="1000">1000</option>
      </select>
    </div>
  </div>
</div>

<!-- MODAL -->
<ng-template #updateReceiver let-c="close">

  <div class="modal-header">
    <h5 class="modal-title" *ngIf="selectedReceiver && selectedReceiver.status == 'A'" translate>cli.receiverList.modalUpdate.titleDesactivate</h5>
    <h5 class="modal-title" *ngIf="selectedReceiver && selectedReceiver.status != 'A'" translate>cli.receiverList.modalUpdate.titleActivate</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="c('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <span *ngIf="selectedReceiver && selectedReceiver.status == 'A'" translate>cli.receiverList.modalUpdate.bodyDesactivate</span>
    <span *ngIf="selectedReceiver && selectedReceiver.status != 'A'" translate>cli.receiverList.modalUpdate.bodyActivate</span>
    <span *ngIf="selectedReceiver && selectedReceiver.status == 'A'" translate>cli.receiverList.modalUpdate.desactivate</span>
    <span *ngIf="selectedReceiver && selectedReceiver.status != 'A'" translate>cli.receiverList.modalUpdate.activate</span>
  </div>
  <div class="modal-footer">
    <div class="botonera">
      <button type="button" (click)="c('cancel')" class="btn btn-secondary" translate>cli.receiverList.modalUpdate.cancel</button>
      <button *ngIf="selectedReceiver && selectedReceiver.status == 'A'" type="button" class="btn btn-primary" (click)="c('update')" translate>cli.receiverList.modalUpdate.btnDesactivate</button>
      <button *ngIf="selectedReceiver && selectedReceiver.status != 'A'" type="button" class="btn btn-primary" (click)="c('update')" translate>cli.receiverList.modalUpdate.btnActivate</button>
    </div>
  </div>

</ng-template>

<!-- MODAL -->
<ng-template #viewUpdateSelectedReceivers let-c="close">

  <div class="modal-header">
    <h5 class="modal-title" *ngIf="!swActivateSelectedReceivers" translate>cli.receiverList.modalUpdateSelected.titleDesactivate</h5>
    <h5 class="modal-title" *ngIf="swActivateSelectedReceivers" translate>cli.receiverList.modalUpdateSelected.titleActivate</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="c('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <span *ngIf="!swActivateSelectedReceivers" translate>cli.receiverList.modalUpdateSelected.bodyDesactivate</span>
    <span *ngIf="swActivateSelectedReceivers" translate>cli.receiverList.modalUpdateSelected.bodyActivate</span>
    <span *ngIf="!swActivateSelectedReceivers" translate>cli.receiverList.modalUpdateSelected.desactivate</span>
    <span *ngIf="swActivateSelectedReceivers" translate>cli.receiverList.modalUpdateSelected.activate</span>
  </div>
  <div class="modal-footer">
    <div class="botonera">
      <button type="button" (click)="c('cancel')" class="btn btn-secondary" translate>cli.receiverList.modalUpdate.cancel</button>
      <button *ngIf="!swActivateSelectedReceivers" type="button" class="btn btn-primary" (click)="c('update')" translate>cli.receiverList.modalUpdateSelected.btnDesactivate</button>
      <button *ngIf="swActivateSelectedReceivers" type="button" class="btn btn-primary" (click)="c('update')" translate>cli.receiverList.modalUpdateSelected.btnActivate</button>
    </div>
  </div>

</ng-template>




// WEBPACK FOOTER //
// ./src/app/app-manager/client/cli-receiver-list/cli-receiver-list.component.html